// @flow weak

import { addTruthyParamsToUrl } from '@zapier/url-utils';

import {
  IMAGE_SERVICE_URL,
  INVALID_IMAGE_CDN_URLS,
} from 'web-ssr/app/common/constants';

export const addProtocolToUrl = (url: string, protocol: string) => {
  const httpProtocolMatch = url.match(/^https?:\/\//);
  if (httpProtocolMatch && httpProtocolMatch.index === 0) {
    return url;
  }

  return `${protocol}${url}`;
};

const replaceImageCDN = (src: string) => {
  const match = INVALID_IMAGE_CDN_URLS.find(url => src.includes(url));

  return match ? src.replace(match, IMAGE_SERVICE_URL) : src;
};

export const buildOptimzedImageUrl = (
  src: string,
  width?: number,
  format?: string,
  background?: string
) =>
  addTruthyParamsToUrl(replaceImageCDN(src), {
    dimensions: width,
    format,
    background,
  });

export const isRelativeAnchorLink = (target: URL) => {
  const { location } = window;

  return Boolean(
    target.hash &&
      location.pathname === target.pathname &&
      location.origin === target.origin
  );
};
